import mustache from "mustache";
import { IRender } from "../../definitions/IRender";
import template from "./sidebarExpandedStatsTemplate.html";

mustache.parse(template);

/** Celda de la grilla de stats (valor destacado + label). */
export type SidebarStat = {
  /** Valor destacado (ya formateado, p. ej. "8.85"). */
  value: string;
  /** Etiqueta de la celda (p. ej. "Área Aplicada Has"). */
  label: string;
};

/** Grilla de stats para el contenido expandido de un item del segundo sidebar
 *  (pieza de composición: mismo estilo en todos los módulos). Render puro. */
export class SidebarExpandedStatsRender implements IRender {
  /** @param _stats Celdas a mostrar (una columna por celda). */
  constructor(private readonly _stats: SidebarStat[]) {}

  render(): string {
    return mustache.render(template, { stats: this._stats });
  }
}
